import React from "react";
import styles from "./styles/ScenarioCardTags.module.css";
import { FaArrowLeft } from "react-icons/fa";

const ScenarioCardTags = ({
    tags,
    searchQuery,
    highlightText,
    handleTagClick,
    onClose,
}) => {
    return (
        <div className={styles.tagsView}>
            <div className={styles.tagsHeader}>
                <button
                    className={styles.backButton}
                    onClick={onClose}
                    aria-label="Back to Scenario Info"
                    title="Back"
                >
                    <FaArrowLeft />
                </button>
                <h4 className={styles.tagsTitle}>Tags ({tags.length})</h4>
            </div>
            <ul className={styles.tagsList}>
                {tags.length > 0 ? (
                    tags.map((tag, index) => (
                        <li key={index} className={styles.tagItem}>
                            <button
                                className={styles.tagButton}
                                onClick={() => handleTagClick(tag)}
                                title={`Filter by tag: ${tag}`}
                            >
                                {highlightText(tag, searchQuery)}
                            </button>
                        </li>
                    ))
                ) : (
                    <li className={styles.noTags}>No tags defined.</li>
                )}
            </ul>
        </div>
    );
};

export default ScenarioCardTags;